/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Stack } from '@towersystems/towersystems-design-system';
import { get } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { getCurrentRental, requestingCurrentRental } from 'state/current-rental/selectors';
import { getCurrentRetailerRentalSubscription, requestingCurrentRetailerRental } from 'state/current-retailer-rental/selectors';
import DateTime from 'components/date-time';
import Money from 'components/money';
import DetailListItem from 'components/detail-list-item';
import cscom from 'lib/customer-site-api';

const BillingDetailsCard = ({ currentRental}) => {
    const [estimate, setEstimate] = useState(null);

    const dueSince = get(currentRental, 'due_since');
    const totalDues = get(currentRental, 'total_dues');
    const nextBillingAt = get(currentRental, 'next_billing_at');

    useEffect(() => {
        requestNextBillingEstimate();
    }, []);

    const requestNextBillingEstimate = () => {
        let subId = get(currentRental, 'id');
        if (!subId) return;

        if (
            !get(currentRental, 'status') ||
            get(currentRental, 'status') == 'cancelled' ||
            get(currentRental, 'status') == 'non_renewing'
        ) {
            return;
        }

        cscom
            .estimate()
            .renewal(subId)
            .then((estimate) => setEstimate(estimate))
            .catch((a) => console.log(a));
    };

    return (
        <Card>
            <Stack>
                {dueSince && totalDues && (
                    <Card.Section>
                        <DetailListItem label='Total due' detail={<Money value={totalDues / 100} />} />
                    </Card.Section>
                )}
                {dueSince && (
                    <Card.Section>
                        <DetailListItem label='Due since' detail={<DateTime date={dueSince} format='Do MMM, YYYY' />} />
                    </Card.Section>
                )}
                <Card.Section>
                    <DetailListItem
                        label='Next billing date'
                        detail={<DateTime date={nextBillingAt} format='Do MMM, YYYY' />}
                    />
                </Card.Section>
                <Card.Section>
                    <DetailListItem
                        label='Esimated next billing amount'
                        detail={estimate ? <Money value={get(estimate, 'invoice_estimate.total', 0) / 100} /> : '-'}
                    />
                </Card.Section>
            </Stack>
        </Card>
    );
};

export default connect((state) => ({
    currentRental: getCurrentRetailerRentalSubscription(state),
    requesting: requestingCurrentRetailerRental(state),
}))(BillingDetailsCard);
